[
    {
        "itemId": "A1001001A17D21B03659D80406",
        "dms2docId": "947781444_1492763813624_0001",
        "dms2docCond": 1,
        "createTs": "2017-04-21T08:36:59.000+02:00",
        "lastChangedTs": "2017-04-21T08:37:00.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": "ALSP_Novouzatvorene_zmluvy~1.xls",
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11542C67989",
        "dms2docId": "947781444_1492766137696_0001",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:15:42.000+02:00",
        "lastChangedTs": "2017-04-21T09:15:43.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": "ALSP_Novouzatvorene_zmluvy~1.xls",
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11601E55135",
        "dms2docId": "947781444_1492766137696_0001_44",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:01.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:01.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11601E62395",
        "dms2docId": "947781444_1492766137696_0001_18",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:01.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:01.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11601E71527",
        "dms2docId": "947781444_1492766137696_0001_10",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:01.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:01.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11602I32247",
        "dms2docId": "947781444_1492766137696_0001_38",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:02.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:02.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11602I72335",
        "dms2docId": "947781444_1492766137696_0001_14",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:02.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:02.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11602I74644",
        "dms2docId": "947781444_1492766137696_0001_12",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:02.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:02.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11603J51326",
        "dms2docId": "947781444_1492766137696_0001_33",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:03.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:03.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11604A54262",
        "dms2docId": "947781444_1492766137696_0001_42",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:04.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:04.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11604A75100",
        "dms2docId": "947781444_1492766137696_0001_30",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:04.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:04.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11604I61551",
        "dms2docId": "947781444_1492766137696_0001_47",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:04.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:04.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11605B11590",
        "dms2docId": "947781444_1492766137696_0001_48",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:05.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:05.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11605B31784",
        "dms2docId": "947781444_1492766137696_0001_13",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:05.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:05.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11605G23306",
        "dms2docId": "947781444_1492766137696_0001_49",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:05.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:05.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11606A36667",
        "dms2docId": "947781444_1492766137696_0001_22",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11606A65579",
        "dms2docId": "947781444_1492766137696_0001_3",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11606E26356",
        "dms2docId": "947781444_1492766137696_0001_39",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11606J03213",
        "dms2docId": "947781444_1492766137696_0001_15",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11606J04041",
        "dms2docId": "947781444_1492766137696_0001_7",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11607C26317",
        "dms2docId": "947781444_1492766137696_0001_34",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:07.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:07.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11607G62288",
        "dms2docId": "947781444_1492766137696_0001_9",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:07.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:07.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11607G71274",
        "dms2docId": "947781444_1492766137696_0001_1",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:07.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:07.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11608A28924",
        "dms2docId": "947781444_1492766137696_0001_11",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11608E49478",
        "dms2docId": "947781444_1492766137696_0001_29",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11608G31551",
        "dms2docId": "947781444_1492766137696_0001_17",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11608I29957",
        "dms2docId": "947781444_1492766137696_0001_27",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11609C29354",
        "dms2docId": "947781444_1492766137696_0001_6",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:09.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:09.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11609E61494",
        "dms2docId": "947781444_1492766137696_0001_5",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:09.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:09.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11610C62675",
        "dms2docId": "947781444_1492766137696_0001_50",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:10.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:10.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11610E57691",
        "dms2docId": "947781444_1492766137696_0001_40",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:10.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:10.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11610E65850",
        "dms2docId": "947781444_1492766137696_0001_20",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:10.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:10.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11611A42349",
        "dms2docId": "947781444_1492766137696_0001_23",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11611C72564",
        "dms2docId": "947781444_1492766137696_0001_43",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11611E42128",
        "dms2docId": "947781444_1492766137696_0001_37",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11611I67801",
        "dms2docId": "947781444_1492766137696_0001_26",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11612A86548",
        "dms2docId": "947781444_1492766137696_0001_46",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11612C77135",
        "dms2docId": "947781444_1492766137696_0001_28",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11612G36887",
        "dms2docId": "947781444_1492766137696_0001_25",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11612I53748",
        "dms2docId": "947781444_1492766137696_0001_19",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11613A60372",
        "dms2docId": "947781444_1492766137696_0001_36",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11613E67185",
        "dms2docId": "947781444_1492766137696_0001_41",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11613G40402",
        "dms2docId": "947781444_1492766137696_0001_8",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11613I45452",
        "dms2docId": "947781444_1492766137696_0001_24",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11614D35117",
        "dms2docId": "947781444_1492766137696_0001_16",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:14.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:14.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11614F04177",
        "dms2docId": "947781444_1492766137696_0001_31",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:14.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:14.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11614G49833",
        "dms2docId": "947781444_1492766137696_0001_21",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:14.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:14.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11615A82555",
        "dms2docId": "947781444_1492766137696_0001_32",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:15.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:15.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11615C91121",
        "dms2docId": "947781444_1492766137696_0001_2",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:15.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:15.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11615E51158",
        "dms2docId": "947781444_1492766137696_0001_45",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:15.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:15.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11615I62704",
        "dms2docId": "947781444_1492766137696_0001_35",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:15.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:15.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11616A53030",
        "dms2docId": "947781444_1492766137696_0001_4",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:16.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:16.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11746I99741",
        "dms2docId": "947781444_1492766263515_0001",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:17:46.000+02:00",
        "lastChangedTs": "2017-04-21T09:17:47.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": "ALSP_Novouzatvorene_zmluvy~1.xls",
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11806C43976",
        "dms2docId": "947781444_1492766263515_0001_23",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11806C44508",
        "dms2docId": "947781444_1492766263515_0001_48",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11806G41957",
        "dms2docId": "947781444_1492766263515_0001_26",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:06.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:06.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11807C73128",
        "dms2docId": "947781444_1492766263515_0001_33",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:07.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:07.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11807E73952",
        "dms2docId": "947781444_1492766263515_0001_21",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:07.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:07.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11807E74711",
        "dms2docId": "947781444_1492766263515_0001_24",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:07.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:07.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11808A10396",
        "dms2docId": "947781444_1492766263515_0001_14",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11808E42434",
        "dms2docId": "947781444_1492766263515_0001_8",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11808E43261",
        "dms2docId": "947781444_1492766263515_0001_34",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:08.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:08.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11809A19744",
        "dms2docId": "947781444_1492766263515_0001_20",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:09.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:09.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11809C51958",
        "dms2docId": "947781444_1492766263515_0001_17",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:09.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:09.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11809E91933",
        "dms2docId": "947781444_1492766263515_0001_4",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:09.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:09.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11809I24553",
        "dms2docId": "947781444_1492766263515_0001_9",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:09.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:09.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11810C37224",
        "dms2docId": "947781444_1492766263515_0001_47",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:10.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:10.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11810C44990",
        "dms2docId": "947781444_1492766263515_0001_10",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:10.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:10.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11810G22258",
        "dms2docId": "947781444_1492766263515_0001_11",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:10.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:10.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11811B00517",
        "dms2docId": "947781444_1492766263515_0001_42",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11811B22718",
        "dms2docId": "947781444_1492766263515_0001_50",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11811E24144",
        "dms2docId": "947781444_1492766263515_0001_29",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:11.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:11.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11812A47101",
        "dms2docId": "947781444_1492766263515_0001_13",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11812A65597",
        "dms2docId": "947781444_1492766263515_0001_1",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11812D17297",
        "dms2docId": "947781444_1492766263515_0001_18",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11812I42655",
        "dms2docId": "947781444_1492766263515_0001_40",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:12.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:12.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11813A28625",
        "dms2docId": "947781444_1492766263515_0001_25",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11813A71200",
        "dms2docId": "947781444_1492766263515_0001_27",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11813G31510",
        "dms2docId": "947781444_1492766263515_0001_44",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:13.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:13.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11814C65614",
        "dms2docId": "947781444_1492766263515_0001_49",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:14.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:14.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11814C74484",
        "dms2docId": "947781444_1492766263515_0001_39",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:14.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:14.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11814I34760",
        "dms2docId": "947781444_1492766263515_0001_12",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:14.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:14.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11815A43813",
        "dms2docId": "947781444_1492766263515_0001_41",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:15.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:15.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11815B02909",
        "dms2docId": "947781444_1492766263515_0001_46",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:15.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:15.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11816A62271",
        "dms2docId": "947781444_1492766263515_0001_37",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:16.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:16.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11816A62503",
        "dms2docId": "947781444_1492766263515_0001_38",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:16.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:16.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11816C90127",
        "dms2docId": "947781444_1492766263515_0001_35",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:16.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:16.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11816I62983",
        "dms2docId": "947781444_1492766263515_0001_6",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:16.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:16.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11816I65452",
        "dms2docId": "947781444_1492766263515_0001_43",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:16.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:16.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11817C38568",
        "dms2docId": "947781444_1492766263515_0001_3",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:17.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:17.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11817G59997",
        "dms2docId": "947781444_1492766263515_0001_15",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:17.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:17.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11817G83168",
        "dms2docId": "947781444_1492766263515_0001_7",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:17.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:17.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11818A42478",
        "dms2docId": "947781444_1492766263515_0001_30",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:18.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:18.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11818G84265",
        "dms2docId": "947781444_1492766263515_0001_31",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:18.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:18.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11818G91463",
        "dms2docId": "947781444_1492766263515_0001_5",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:18.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:18.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11819A94119",
        "dms2docId": "947781444_1492766263515_0001_2",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:19.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:19.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11819F55889",
        "dms2docId": "947781444_1492766263515_0001_22",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:19.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:19.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11819G84622",
        "dms2docId": "947781444_1492766263515_0001_28",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:19.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:19.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11819J03298",
        "dms2docId": "947781444_1492766263515_0001_19",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:19.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:19.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11820F07744",
        "dms2docId": "947781444_1492766263515_0001_32",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:18:20.000+02:00",
        "lastChangedTs": "2017-04-21T09:18:20.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    }
]